import i18n from "i18next";
import { LanguageNameSpaces } from "@shared/types";
import { TranslationKeys } from "@shared/common/i18n/types";

const OPTION_NAME_TO_TRANSLATION_KEY = new Map<
  string,
  TranslationKeys<LanguageNameSpaces.COMMON>
>(
  Object.entries({
    "Average Entries": "option_names.average_entries",
    Breakeven: "option_names.breakeven",
    "Custom Amount": "option_names.custom_amount",
    "Entry fill": "option_names.entry_fill",
    "First Entry": "option_names.first_entry",
    "Fixed Btc Amount": "option_names.fixed_btc_amount",
    "Fixed Usd Amount": "option_names.fixed_usd_amount",
    Limit: "option_names.limit",
    Market: "option_names.market",
    "Moving Target": "option_names.moving_target",
    "Moving 2 Target": "option_names.moving_2_target",
    "No Grace": "option_names.no_grace",
    "Original First Entry": "option_names.original_first_entry",
    "Pair Amount": "option_names.pair_amount",
    Percent: "option_names.percent",
    "Percent Below Highest": "option_names.percent_below_highest",
    "Percent Below Triggers": "option_names.percent_below_triggers",
    Percentage: "option_names.percentage",
    Target: "option_names.target",
    Isolated: "option_names.isolated",
    Cross: "option_names.cross",
    Long: "option_names.long",
    Short: "option_names.short",
    Arithmetic: "option_names.arithmetic",
    Geometric: "option_names.geometric",
    Custom: "option_names.custom",
    "Last Entry": "option_names.last_entry",
    "Previous Grid": "option_names.previous_grid",
    "First Grid": "option_names.first_grid",
    "Last Grid": "option_names.last_grid",
    "Hedge Mode": "option_names.hedge_mode",
    "One-Way Mode": "option_names.one_way_mode",
    Group: "option_names.group",
    "DCA Bot": "option_names.dca_bot",
    "Grid Bot": "option_names.grid_bot",
    "Hedging Bot": "option_names.hedging_bot",
    Manual: "option_names.manual",
    "TradingView Bot": "option_names.tradingview_bot",
    "Signal Bot": "option_names.signal_bot",
    "Website & App": "option_names.website_and_app",
    Channel: "option_names.channel",
    Personal: "option_names.personal",
    Dynamic: "option_names.dynamic",
    All: "option_names.all",
    Off: "option_names.off",
    On: "option_names.on",
    "User Configuration": "option_names.user_configuration",
    Spot: "option_names.spot",
    Futures: "option_names.futures",
    Trigger: "option_names.trigger",
    Crypto: "option_names.crypto",
    Type: "option_names.type",
    "Trailing Percent": "option_names.trailing_percent",
    Margin: "option_names.margin",
    "Credit Card": "option_names.credit_card",
  } satisfies Record<string, TranslationKeys<LanguageNameSpaces.COMMON>>)
);

export const translateOptionName = <T extends string | undefined>(name: T) => {
  const key = name ? OPTION_NAME_TO_TRANSLATION_KEY.get(name) : undefined;
  return (
    key ? i18n.t(`${LanguageNameSpaces.COMMON}:${key}`) : name
  ) as T extends string ? string : string | undefined;
};
